/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInValidateInput
 */
export interface MoneyInValidateInput {
    /**
     * Amount to Debit
     * Amounts are displaed as an integer in cents (Euro)
     * @type {number}
     * @memberof MoneyInValidateInput
     */
    totalAmount: number;
    /**
     * Your fee
     * Amounts are given in integers in cents
     * @type {number}
     * @memberof MoneyInValidateInput
     */
    commissionAmount?: number;
    /**
     * Leave empty
     * @type {string}
     * @memberof MoneyInValidateInput
     */
    specialConfig?: string;
}

/**
 * Check if a given object implements the MoneyInValidateInput interface.
 */
export function instanceOfMoneyInValidateInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "totalAmount" in value;

    return isInstance;
}

export function MoneyInValidateInputFromJSON(json: any): MoneyInValidateInput {
    return MoneyInValidateInputFromJSONTyped(json, false);
}

export function MoneyInValidateInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInValidateInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalAmount': json['totalAmount'],
        'commissionAmount': !exists(json, 'commissionAmount') ? undefined : json['commissionAmount'],
        'specialConfig': !exists(json, 'specialConfig') ? undefined : json['specialConfig'],
    };
}

export function MoneyInValidateInputToJSON(value?: MoneyInValidateInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalAmount': value.totalAmount,
        'commissionAmount': value.commissionAmount,
        'specialConfig': value.specialConfig,
    };
}

